<template>
  <div class="w-full">
    <ValidationObserver
        ref="observer"
        class="transition duration-500 ease-in-out transform w-full"
        style="transition: all 1s !important"
        tag="form"
        @submit.prevent="submit()"
    >
      <div class="w-full flex py-5 px-5">
        <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
          <v-card-text v-if="formValues.editMode == false">
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Full Name:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.prefix
                        ? formValues.prefix
                        : ""
                  }}
                  {{
                    formValues.fullName
                        ? formValues.fullName
                        : "-"
                  }}
                </p>
              </div>

              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Gender:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.gender
                        ? formValues.gender
                        : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Phone Number:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{ formValues.phoneNumber ? formValues.phoneNumber : "-" }}
                </p>
              </div>
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Licence Number:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.licenseNumber
                        ? formValues.licenseNumber
                        : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Employee Id:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{ formValues.employeeId ? formValues.employeeId : "-" }}
                </p>
              </div>
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Unemployed?</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.unemployed
                        ? "Yes"
                        : "No"
                  }}
                </p>
              </div>
            </div>
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Facility:</p>
              </div>
              <div class="w-1/3 h-8 pr-2">
                <p class="font-weight-medium">
                  {{
                    formValues.facility
                        ? formValues.facility.name
                        : "-"
                  }}
                </p>
              </div>

              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Email:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.facilityEmail
                        ? formValues.facilityEmail
                        : "-"
                  }}
                </p>
              </div>

            </div>
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Health Profession:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{ formValues.healthProfession ? formValues.healthProfession.name : "-" }}
                </p>
              </div>
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Region:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.woreda
                        ? (formValues.woreda.zone ? (formValues.woreda.zone.location ? formValues.woreda.zone.location.name :
                            "-") : "-")
                        : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Zone:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.woreda
                        ? (formValues.woreda.zone ? formValues.woreda.zone.name : "-")
                        : "-"
                  }}
                </p>
              </div>
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Woreda:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.woreda
                        ? formValues.woreda.name
                        : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="flex my-4 mb-2">
              <div class="w-1/3 h-8">
                <p class="text-md-left font-weight-bold">Kebele:</p>
              </div>
              <div class="w-1/3 h-8">
                <p class="font-weight-medium">
                  {{
                    formValues.kebele
                        ? formValues.kebele
                        : "-"
                  }}
                </p>
              </div>
              <div class="w-1/3 h-8">
              </div>
              <div class="w-1/3 h-8">
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>

          <!--  div class="w-full flex py-5 px-5">
       <v-card flat class="mx-auto w-full" max-width="1000" max-height="auto">
         -->
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Trainee Location</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select
                    v-model="formValues.locationId"
                    :elevation="1"
                    :items="REGIONS"
                    :loading="locationLoading"
                    dense
                    hint="Select location"
                    item-text="name"
                    item-value="id"
                    solo
                >
                </v-select>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >CPD Activity</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select
                    v-model="selectedCategory"
                    :clearable="true"
                    :elevation="1"
                    :items="CATEGORIES"
                    :loading="cpdActLoading"
                    dense
                    hint="Select cpd activity"
                    item-text="name"
                    item-value="id"
                    solo
                    @change="categoryChanged($event)"
                >
                </v-select>

                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
              <div v-if="formValues.programId" class="my-6">
                <p
                    class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
                >
                  courses registered under this CPD Activity
                </p>
                <!-- <v-sub-header>Course registered under this program</v-sub-header> -->
                <v-list v-if="COURSES.length > 0" class="ml-8">
                  <v-list-item-group
                      v-model="formValues.courseIds"
                      color="indigo"
                      multiple
                  >
                    <template v-for="(item, i) in COURSES">
                      <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                      <v-list-item
                          v-else
                          :key="`item-${i}`"
                          :value="item.course ? item.course.id : item.id"
                          active-class="deep-blue--text text--accent-4"
                      >
                        <template v-slot:default="{ active }">
                          <v-list-item-content>
                            <v-list-item-title
                                v-text="
                                `${
                                  item.course
                                    ? item.course.courseName
                                    : item.courseName
                                }`
                              "
                            ></v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-checkbox
                                :input-value="active"
                                color="deep-blue accent-4"
                            ></v-checkbox>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>

                <div v-if="COURSES.length === 0" class="ml-8">
                  <v-icon left>mdi-circle-info</v-icon>
                  <span>No courses registered under this CPD Activity!</span>
                </div>
              </div>
            </div>
            <div v-if="COURSES.length !== 0" class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Course(Category 1)</label
              >
              <!-- <validation-provider v-slot="{ errors }"> -->
              <v-autocomplete
                  v-model="formValues.course"
                  :clearable="true"
                  :items="COURSES"
                  :loading="courseLoading"
                  :searchable="true"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                "
                  hint="Select course"
                  item-text="course.courseName"
                  persistent-hint
                  return-object
              >
              </v-autocomplete>

              <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span> -->
              <!-- </validation-provider> -->
              <br/>
            </div>
            <div
                v-else-if="CATEGORY2_COURSES.length !== 0"
                class="w-full md:w-1/2 px-3 mb-6"
            >
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Course(Category 2)</label
              >
              <v-autocomplete
                  v-model="formValues.category2Course"
                  :clearable="true"
                  :items="CATEGORY2_COURSES"
                  :loading="courseLoading"
                  :searchable="true"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                "
                  hint="Select course"
                  item-text="courseTitleCat2"
                  item-value="id"
                  persistent-hint
              >
              </v-autocomplete>
            </div>
            <div v-else class="pl-4">
              <p class="grey--text">
                <v-icon class="mr-1" left>mdi-information-variant</v-icon>
                No courses to display untill cpd activity selected.
              </p>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6"></div>
            <div class="flex flex-wrap my-6 mx-6 mb-6">
              <div class="w-full">
                <button
                    class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                    @click="submit()"
                >
                  {{ formValues.editMode ? "Update Course" : "Assign course " }}
                </button>
              </div>
              <div class="md:w-2/3"></div>
            </div>
          </div>
        </v-card>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {getCategories, getPrograms, getRegionList, getTrainers,} from "@/utils/helper";
import {LookupService} from "@/common/api.service";
import {TraineeService} from "@/components/Trainees/trainees.service";

extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  props: {
    newTrainee: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      values: {
        id: "",
        courseid: "",
        creditHours: "",
        trainingProvider: "",
        person: {
          firstName: "",
          lastName: "",
          middleName: "",
          licenseNumber: "",
          tin: "",
          healthProfessionId: null,
          phoneNumber: "",
          woredaId: null,
          unemployed: null,
          editMode: false,
        },
        startDate: "",
        endDate: "",
      },
      formValues: {
        traineeId: null,
        locationId: null,
        cpdActivityId: null,
        course: null,
        category2Course: null,
        editMode: false,
        person: {
          firstname: null,
          middlename: null,
          lastname: null,
          gender: null,
          practitionerId: null,
          licenseNumber: null,
        },
      },
      COURSES: [],
      CPD_ACTIVITIES: [],
      TRAINERS: [],
      REGIONS: [],
      showProgress: false,
      editCount: 0,
      locationLoading: false,
      CATEGORIES: [],
      cpdActLoading: false,
      selectedCategory: null,
      courseLoading: false,
      CATEGORY2_COURSES: [],
      cpdActivityChangeCount: 0,
      clearable: null,
      searchable: null,

      NEW_TRAINEE_FACILITIES: [],
      facilityLoading: true,
      traineeFacility: null,
      facilityEdit: false
    };
  },
  async created() {
    await this.initLookups();
    if (this.newTrainee != null) {
      this.formValues = this.newTrainee;
      this.traineeFacility = this.newTrainee?.facility;
      this.facilityEdit = this.newTrainee?.facility ? false : true;
      this.newTrainee.trainee
          ? (this.formValues.editMode = true)
          : (this.formValues.editMode = false);

      if (this.formValues.editMode == true) {

        if (this.formValues.newt_cat2_course) {
          const categoryId = this.formValues.newt_cat2_course.program
              .categoryId;
          this.selectedCategory = categoryId;

        } else if (this.formValues.new_trainees_course) {
          const categoryId = this.formValues.new_trainees_course.program
              .categoryId;
          this.selectedCategory = categoryId;

        }

        this.categoryChanged(this.selectedCategory);
      }
    }
  },
  methods: {
    async initLookups() {
      this.locationLoading = true;
      this.cpdActLoading = true;
      this.REGIONS = await getRegionList();
      this.locationLoading = false;
      this.CATEGORIES = await getCategories();
      const cpdActRes = await getPrograms();
      this.CPD_ACTIVITIES = cpdActRes.data?.rows ? cpdActRes.data.rows : null;
      this.cpdActLoading = false;
      this.TRAINERS = await getTrainers();
      let tempres = await LookupService.getTraineeFacilities();
      this.NEW_TRAINEE_FACILITIES = tempres.data.rows;
      this.facilityLoading = false;
    },
    categoryChanged(event) {
      this.courseLoading = true;
      const courses = [];
      const category2Courses = [];
      this.formValues.course = null;
      this.formValues.category2Course = null;

      this.CPD_ACTIVITIES.forEach((program) => {
        if (event == program.categoryId) {
          if (program.category?.categoryType == "CAT1") {
            const programCourses = program.program_courses;
            for (let index = 0; index < programCourses.length; index++) {
              const element = programCourses[index];
              courses.push(element);
            }
          } else {
            category2Courses.push(program);
          }
        }
      });
      this.COURSES = courses ? courses : null;
      this.CATEGORY2_COURSES = category2Courses ? category2Courses : null;
      if (
          this.formValues.editMode == true &&
          this.cpdActivityChangeCount == 0
      ) {
        if (this.formValues.newt_cat2_course) {
          this.formValues.category2Course = this.formValues.newt_cat2_course.programId;
          this.formValues.course = null;
        } else {
          this.formValues.course = this.formValues.new_trainees_course;
          this.formValues.category2Course = null;
        }
      }

      this.courseLoading = false;
      this.cpdActivityChangeCount += 1;
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      if (this.formValues.editMode == false) {
        this.formValues.traineeId = this.formValues.id;
        delete this.formValues.id;
      }
      this.$emit("registerOrUpdateNewTrainee", this.formValues);
      this.$emit("close");
    },
    async updateTrainee(id) {
      console.log('traineeid', id)
      console.log('facility', this.traineeFacility)
      // this.facilityEdit = false;
      const res = TraineeService.updateNewTrainee(id, {});
      console.log(res);
    },
  },
};
</script>
<style scoped>
.contact-wrapper:nth-child(2) {
  padding-left: 0px !important;
}

.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
